// useStaticPopperActionPopup.js
import { useState, useRef, useEffect } from 'react';
import useClickOutside from './useClickOutside';

const useStaticPopperActionPopup = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [menuStyles, setMenuStyles] = useState({});
  const buttonRef = useRef(null);
  const menuRef = useRef(null);

  const calculatePosition = () => {
    if (!buttonRef.current || !menuRef.current)
      return;
    const buttonRect = buttonRef.current.getBoundingClientRect();
    const menuRect = menuRef.current.getBoundingClientRect();

    setMenuStyles({
      position: "fixed",
      top: buttonRect.top - 3,
      left: buttonRect.left - menuRect.width + 3,
      zIndex: 35
    });
  };

  const toggleMenu = () => {
    setShowMenu(prev => {
      const next = !prev;
      if (!prev)
        setTimeout(calculatePosition, 0);
      return next;
    });
  };

  const closeMenu = () => setShowMenu(false)

  useClickOutside(menuRef, () => {
    if (showMenu)
      closeMenu();
  });

  useEffect(() => {
    if (showMenu) {
      requestAnimationFrame(calculatePosition);
      window.addEventListener('scroll', closeMenu, true);
      window.addEventListener('resize', closeMenu);
      document.addEventListener('keydown', (e) => e.key === 'Escape' && closeMenu());
    }
    return () => {
      window.removeEventListener('scroll', closeMenu, true);
      window.removeEventListener('resize', closeMenu);
      document.removeEventListener('keydown', (e) => e.key === 'Escape' && closeMenu());
      document.removeEventListener('touchstart', closeMenu);
      document.removeEventListener('mousedown', closeMenu);
    };
  }, [showMenu, calculatePosition, closeMenu]);


  return { showMenu, menuStyles, buttonRef, menuRef, toggleMenu, closeMenu };
};

export default useStaticPopperActionPopup;
